import { useCallback, useEffect } from 'react';
import type { NoticiaPublica } from '../data/noticias';
import { suscribirseANoticias } from '../services/noticiasEventos';
import { getNoticiasPublicas, noticiasIniciales } from '../services/noticiasPublicas';
import { useAsyncData, type EstadoAsincrono } from './useAsyncData';

/**
 * Noticias visibles en la web pública, al día.
 *
 * Además de cargarlas al montar, se suscribe a los cambios: cuando alguien
 * aprueba, edita o borra una noticia desde el panel, el servicio avisa y esto
 * vuelve a pedir el listado. Así el home y la página de Noticias se refrescan
 * solos, sin recargar y sin sondear al backend cada pocos segundos.
 */
export function useNoticiasPublicas(): EstadoAsincrono<NoticiaPublica[]> {
  const cargar = useCallback((signal: AbortSignal) => getNoticiasPublicas(signal), []);
  const estado = useAsyncData<NoticiaPublica[]>(cargar, noticiasIniciales());

  const { recargar } = estado;

  // `suscribirseANoticias` devuelve ya la funcion de baja, que es justo lo que
  // el efecto necesita como limpieza.
  useEffect(() => suscribirseANoticias(recargar), [recargar]);

  return estado;
}
